import React from 'react';
import Button from '@mui/material/Button';
import { isString } from 'utilities/is';

export default (props) => {
    let eventName = '';

    // console.debug('EventButton props', props);
    if (isString(props.children)) {
        eventName = props.children;
    } else if (props.children.forEach) {
        props.children.forEach(c => {
            if (typeof c === 'string' || c instanceof String) {
                eventName = c.replaceAll(' ', '');
                return;
            }
        });
    }
    const propEventName = props['data-id'];
    
    // data-id is used to name the button for the telemetry date sent to app insights
    if (propEventName)
        eventName = propEventName;

    return (
        <Button data-id={eventName} {...props}>
            {props.children}
        </Button>
    );
};